<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title justify-content">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.WorkflowReportsTable.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="
                                            tables.WorkflowReportsTable.allFields
                                        "
                                        :activeFields.sync="
                                            tables.WorkflowReportsTable.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <h6>
                                    {{ $t("leads_received_description") }}
                                </h6>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.WorkflowReportsTable.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.WorkflowReportsTable
                                                .fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.WorkflowReportsTable.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.WorkflowReportsTable.rows
                                    "
                                    v-bind="tables.WorkflowReportsTable"
                                >
                                    <template #storage_key="{ item }">
                                        <td>
                                            <a href="#"
                                                @click="downloadWorkflowReport(item)"
                                            >
                                            {{ item.storage_key }}
                                            </a>
                                        </td>
                                    </template>
                                    <template #_selected="{ index }">
                                        <td class="py-2">
                                            <CInputCheckbox
                                                :checked.sync="
                                                    tables.WorkflowReportsTable
                                                        .items[index]._selected
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/campaigns.api/' +
                                                    uuid +
                                                    '/pendings'
                                                "
                                                :table="tables.WorkflowReportsTable"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.WorkflowReportsTable.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.WorkflowReportsTable.page
                                        "
                                        :pages="
                                            tables.WorkflowReportsTable.total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.WorkflowReportsTable.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";
/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";

import WorkflowReportsTable from "./config/tables/WorkflowReportsTable.js";

export default {
    name: "WorkflowReportsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        ButtonExport,
        FilterFields
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                WorkflowReportsTable
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "WorkflowReportsTable",
                url: `/campaigns.api/${this.uuid}/workflow/reports`
            });
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        async downloadWorkflowReport(item){
            try {
                this.updatePageLoading(true);
                let data = await this.fetcher({
                    url: `/campaigns.api/${this.uuid}/workflow/reports/${item.uuid}/download`,
                    method: "GET"
                });
                this.downloadFileFromURL(data._items.presigned_url);
                this.showMessageSuccess();
                this.updatePageLoading(false);
            } catch (error) {
                this.showMessageError(error);
            }
        }
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss">
</style>